import React from "react";

import productService from "../services/productService";

import { showProcess, hideProcess, UserSession, getFileServer } from "../utils/util";
import { Galleria } from "primereact/galleria";
import Banner001 from "../img/Banner001.png";

import { useParams } from "react-router-dom";
import { InputNumber } from "primereact/inputnumber";
import shoppingCartService from "../services/shoppingCartService";
import userService from "../services/userService";
import { Checkbox } from "primereact/checkbox";
import { Paginator } from "primereact/paginator";
import saleOrderService from "../services/saleOrderService";
import { Timeline } from "primereact/timeline";

function withParams() {
    return (props) => <SaleOrder {...props} params={useParams()} />;
}

class SaleOrder extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            first: 0,
            rows: 10,
            totalRecords: 0,
            saleOrders: [],
            fileServer: getFileServer(),
        };
    }

    async componentDidMount() {
        try {
            await showProcess();

            var response = await saleOrderService.getById(this.props.params.id);

            this.setState({ saleOrder: response.data });

            window.addEventListener("resize", this.handleResize);
        } catch (err) {
            if (err.response) {
                console.log("status", err.response.status);
                console.log("headers", err.response.headers);
                console.log("data", err.response.data); // <- aqui normalmente vem a dica do que faltou
            } else {
                console.log("message", err.message);
            }
        }

        hideProcess();
    }

    handleResize = () => {
        this.setState({ windowWidth: window.innerWidth });
    };

    formatarTelefone(telefone) {
        telefone = telefone.replace(/\D/g, "");

        // Verifica se tem DDD
        if (telefone.length <= 10) {
            // Formato: (XX) XXXX-XXXX
            return telefone.replace(/(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");
        } else {
            // Formato: (XX) XXXXX-XXXX
            return telefone.replace(/(\d{2})(\d{5})(\d{0,4})/, "($1) $2-$3");
        }
    }

    render() {
        if (UserSession === null || UserSession === undefined || UserSession === "") {
            window.location.href = "/login";
            return;
        }
        return (
            <div
                style={{
                    padding: this.state.windowWidth < 768 ? "15px" : "40px",
                    overflowX: "hidden",
                    boxSizing: "border-box",
                    width: "100%",
                }}
            >
                <div>
                    {this.state.saleOrder && (
                        <>
                            <div
                                style={{
                                    textAlign: this.state.windowWidth < 768 ? "center" : "left",
                                    marginBottom: this.state.windowWidth < 768 ? "30px" : "50px",
                                }}
                            >
                                <div
                                    style={{
                                        padding: this.state.windowWidth < 768 ? "10px" : "20px",
                                        overflowX: "hidden",
                                        boxSizing: "border-box",
                                        width: "100%",
                                    }}
                                >
                                    <a
                                        href="/"
                                        style={{
                                            color: "#209ADB",
                                            textDecoration: "underline",
                                            fontSize: this.state.windowWidth < 768 ? "14px" : "16px",
                                        }}
                                    >
                                        Home
                                    </a>
                                    <span style={{ marginLeft: "10px" }} />
                                    <a
                                        style={{
                                            color: "#209ADB",
                                            textDecoration: "underline",
                                            fontSize: this.state.windowWidth < 768 ? "14px" : "16px",
                                        }}
                                    >
                                        Configurações
                                    </a>
                                    <span style={{ marginLeft: "10px" }} />
                                    <a
                                        href="/orders"
                                        style={{
                                            color: "#209ADB",
                                            textDecoration: "underline",
                                            fontSize: this.state.windowWidth < 768 ? "14px" : "16px",
                                        }}
                                    >
                                        Meus Pedidos
                                    </a>
                                </div>
                            </div>

                            <table
                                style={{
                                    width: "100%",
                                    textAlign: "center",
                                    borderCollapse: "collapse",
                                }}
                            >
                                <tr>
                                    <td style={{ width: "33%" }}>
                                        <span
                                            style={{
                                                fontSize: "22px",
                                                color: "var(--unnamed-color-411172)",
                                            }}
                                        >
                                            Pedido#
                                        </span>
                                    </td>
                                    <td style={{ width: "33%" }}>
                                        <span
                                            style={{
                                                fontSize: "22px",
                                                color: "var(--unnamed-color-411172)",
                                            }}
                                        >
                                            Valor do Pedido
                                        </span>
                                    </td>
                                    <td style={{ width: "33%" }}>
                                        <span
                                            style={{
                                                fontSize: "22px",
                                                color: "var(--unnamed-color-411172)",
                                            }}
                                        >
                                            Ítens do Pedido
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <span
                                            style={{
                                                fontSize: "22px",
                                                color: "var(--unnamed-color-411172)",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {this.state.saleOrder.id}
                                        </span>
                                    </td>
                                    <td>
                                        <span
                                            style={{
                                                fontSize: "22px",
                                                color: "var(--unnamed-color-411172)",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            R$
                                            {this.state.saleOrder.amount.toLocaleString("pt-BR", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })}
                                        </span>
                                    </td>
                                    <td>
                                        <span
                                            style={{
                                                fontSize: "22px",
                                                color: "var(--unnamed-color-411172)",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {this.state.saleOrder.lines.length}
                                        </span>
                                    </td>
                                </tr>
                            </table>

                            {/* Tabela de produtos */}
                            <table
                                style={{
                                    marginTop: "50px",
                                    width: "100%",
                                    borderCollapse: "collapse",
                                }}
                            >
                                {this.state.saleOrder.lines.map((line, index) => (
                                    <tr
                                        key={index}
                                        style={{
                                            display:
                                                this.state.windowWidth < 768 ? "block" : "table-row",
                                            marginBottom: this.state.windowWidth < 768 ? "30px" : "0",
                                            borderBottom:
                                                this.state.windowWidth < 768 ? "1px solid #eee" : "none",
                                        }}
                                    >
                                        <td
                                            style={{
                                                verticalAlign: "top",
                                                width: this.state.windowWidth < 768 ? "100%" : "300px",
                                                textAlign:
                                                    this.state.windowWidth < 768 ? "center" : "left",
                                                display:
                                                    this.state.windowWidth < 768
                                                        ? "block"
                                                        : "table-cell",
                                            }}
                                        >
                                            <img
                                                src={`${this.state.fileServer}/cards/${line.product.id}.png`}
                                                alt="Gamers Fans"
                                                style={{
                                                    width:
                                                        this.state.windowWidth < 768 ? "100%" : "308px",
                                                    height:
                                                        this.state.windowWidth < 768 ? "auto" : "180px",
                                                    maxWidth: "100%",
                                                    borderRadius: "8px",
                                                }}
                                            />
                                        </td>
                                        <td
                                            style={{
                                                verticalAlign: "top",
                                                paddingLeft: this.state.windowWidth < 768 ? "0" : "25px",
                                                textAlign:
                                                    this.state.windowWidth < 768 ? "center" : "left",
                                                display:
                                                    this.state.windowWidth < 768
                                                        ? "block"
                                                        : "table-cell",
                                                paddingTop: this.state.windowWidth < 768 ? "10px" : "0",
                                            }}
                                        >
                                            <span
                                                style={{
                                                    fontSize:
                                                        this.state.windowWidth < 768 ? "1.3em" : "25px",
                                                    color: "var(--unnamed-color-411172)",
                                                    fontWeight: "bold",
                                                    display: "block",
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                {line.product.displayName}
                                            </span>
                                            <span
                                                style={{
                                                    fontSize:
                                                        this.state.windowWidth < 768 ? "1em" : "16px",
                                                    color: "var(--unnamed-color-411172)",
                                                    display: "block",
                                                    marginBottom: "8px",
                                                }}
                                            >
                                                R$
                                                {line.amount.toLocaleString("pt-BR", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                })}
                                            </span>
                                            <span
                                                style={{
                                                    fontSize:
                                                        this.state.windowWidth < 768 ? "0.9em" : "16px",
                                                    color: "var(--unnamed-color-411172)",
                                                    display: "block",
                                                    lineHeight: "1.4em",
                                                }}
                                            >
                                                Seu gift-card será enviado para {UserSession.name}
                                                <br />
                                                para o e-mail {UserSession.email}
                                            </span>
                                            <span
                                                style={{
                                                    fontSize:
                                                        this.state.windowWidth < 768 ? "0.9em" : "16px",
                                                    color: "var(--unnamed-color-411172)",
                                                    display: "block",
                                                    lineHeight: "1.4em",
                                                }}
                                            >
                                                Status do item:{" "}
                                                <span
                                                    className={`pi ${SaleOrderLineStatus[line.status].icon}`}
                                                    style={{
                                                        color: SaleOrderLineStatus[line.status]
                                                            .color,
                                                        marginLeft: "5px",
                                                        fontSize: "16px",
                                                    }}
                                                />{" "}
                                                {SaleOrderLineStatus[line.status].label}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </table>
                        </>
                    )}
                </div>
            </div>
        );
    }
}

const SaleOrderLineStatus = {
    PENDING: { label: "Pendente", color: "#FFA500", icon: "pi-stopwatch" },
    DELIVERED: { label: "Entregue", color: "#008000", icon: "pi-check-circle" },
    CANCELED: { label: "Cancelado", color: "#FF0000", icon: "pi-times-circle" },
    ACTIVATED: { label: "Ativado", color: "#008000", icon: "pi-check-circle" },
    DENIED: { label: "Negado", color: "#FF0000", icon: "pi-times-circle" },
    PAID: { label: "Pago", color: "#008000", icon: "pi-dollar" },
    AWAITING_PAYMENT: {
        label: "Aguardando Pagamento",
        color: "#FF0000",
        icon: "pi-dollar",
    },
    PAYMENT_UNDER_ANALYSIS: {
        label: "Pagamento em Análise",
        color: "#FFA500",
        icon: "pi-dollar",
    },
};

export default withParams();
